import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { triggerAlert } from '../../utils/commonFunctions';
import { forgotPassword } from '../../utils/APIClient';

const ForgotPassword = () => {
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm();
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = async (data) => {
        setIsLoading(true);
        try {
            const response = await forgotPassword({ email: data.email.trim() });
            const respdata = response.data;
            if (respdata.status_code === 200) {
                triggerAlert('success', '', respdata.message);
                Navigate('/login', { replace: true });
            }
        } catch (error) {
            let errorMessage = 'Something went wrong';
            
            if (error?.response?.data) {
                const responseData = error.response.data;
                if (responseData.email && Array.isArray(responseData.email) && responseData.email.length > 0) {
                    errorMessage = responseData.email[0];
                } else if (responseData.message) {
                    errorMessage = responseData.message;
                } else if (responseData.error) {
                    errorMessage = responseData.error;
                } else if (responseData.detail) {
                    errorMessage = responseData.detail;
                }
            }
            
            triggerAlert('error', '', errorMessage);
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-fluid">
            <div className="auth-fluid-form-box">
                <div className="card-body d-flex flex-column h1-100" style={{ height: '70%' }}>
                    <div className="auth-brand text-center text-lg-start">
                        <Link to="/" className="logo-dark">
                            <span><img src="/assets/images/logo.png" alt="dark logo" height={70} /></span>
                        </Link>
                    </div>
                    <div className="my-auto">
                        <h3 className="mt-0">Forgot Password</h3>
                        <p className="mb-4 text-muted">Enter your email address to receive a password reset link.</p>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="mb-3">
                                <label htmlFor="emailaddress" className="form-label">Email address<span className="text-danger"> *</span></label>
                                <input
                                    type="text"
                                    id="emailaddress"
                                    {...register("email", {
                                        required: "Email is required",
                                        pattern: {
                                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                            message: "Please enter a valid email address"
                                        },
                                        maxLength: {
                                            value: 150,
                                            message: "Email cannot exceed 150 characters"
                                        },
                                        validate: value => {
                                            const trimmedValue = value.trim();
                                            if (trimmedValue !== value) {
                                                return "Email cannot have leading or trailing spaces";
                                            }
                                            if (trimmedValue.length === 0) {
                                                return "Email cannot be just spaces";
                                            }
                                            return true;
                                        }
                                    })}
                                    className="form-control"
                                    placeholder="Enter your email address"
                                    autoComplete="email"
                                />
                                {errors.email && <small className="text-danger d-block mt-1">{errors.email.message}</small>}
                            </div>
                            <div className="d-grid mb-0 text-center">
                                <button className="btn btn-success" type="submit" disabled={isLoading}>
                                    <i className="ri-mail-send-line me-1"></i>
                                    {isLoading ? 'Sending...' : 'Send Reset Link'}
                                </button>
                            </div>
                        </form>
                        <p className="mt-3 text-center">
                            <i className="ri-arrow-left-line me-1"></i>
                            Go back to <Link to="/login" className="text-warning"><b>Login</b></Link>
                        </p>
                    </div>
                    <footer className="footer footer-alt">
                        <p className="text-center">Don't have an account? <Link to="/signup" className="text-warning ms-1"><b>Sign Up</b></Link></p>
                    </footer>
                </div>
            </div>
            <div className="auth-fluid-right text-center">
                <div className="auth-user-testimonial">
                    <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item">
                                <h2 className="mb-2 text-info">Seamless Voice Integration with Callingo</h2>
                                <p className="lead"><i className="ri-double-quotes-l" /> Using Callingo, I effortlessly built a Shopify app to recover abandoned checkouts, avoiding the usual hassle of integrating multiple APIs and dealing with latency or unnatural voice interruptions.</p>
                                <p>- Charlie Stigler (Founder, SpeakSage)</p>
                            </div>
                            <div className="carousel-item">
                                <h2 className="mb-2 text-info">Relevance AI</h2>
                                <p className="lead"><i className="ri-double-quotes-l" /> Built an AI sales that do Cold Call & WhatsApp follow-up - powered by Callingo</p>
                                <p>- Kwindla Kramer</p>
                            </div>
                            <div className="carousel-item active">
                                <h2 className="mb-2 text-info">Feature Availability!</h2>
                                <p className="lead"><i className="ri-double-quotes-l" /> This is a great product, helped us a lot and very quick to work with and implement.</p>
                                <p>- TryDaily</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
